import { render } from "./karussellSwiperHaustueren.vue?vue&type=template&id=d407105a"
import script from "./karussellSwiperHaustueren.vue?vue&type=script&lang=js"
export * from "./karussellSwiperHaustueren.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__